import Cookies from 'js-cookie';
import { TokenRepository as ITokenRepository } from '../../domain/repositories/TokenRepository';

/**
 * Infrastructure implementation of TokenRepository
 * Handles the storage and retrieval of authentication tokens using cookies
 */
export class TokenRepository implements ITokenRepository {
  private readonly TOKEN_KEY = 'token';
  private readonly EXPIRY_DAYS = 1;

  /**
   * Store the token in cookies
   */
  setToken(token: string): void {
    Cookies.set(this.TOKEN_KEY, token, { expires: this.EXPIRY_DAYS, secure: true });
  }

  /**
   * Get the token from cookies
   */
  getToken(): string | undefined {
    return Cookies.get(this.TOKEN_KEY);
  }

  /**
   * Remove the token from cookies
   */
  removeToken(): void {
    Cookies.remove(this.TOKEN_KEY);
  }
}
